module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAPFBMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t2Zoqg9REgpLzPM1t3M1t3BaU/BaU/BaU/BaU/gtKf////M1dqZqrXLueYJAAAAEHRSTlMAIJ/v/wAw////UN9Q3/8A1l+fIwAAAO5JREFUeAHt2N2KhDAMhmE1345/bcfo/d/rwrjFDhXNpLK7Qt4jQXgwbY6szqobAqipv06qTt4/CK/oUQbVhLbr+64F1UVQg7Z/1aIpggjdCnWgIgjofwI+h4YRsQTaGgcZNCBpGy1tEEEjkrbDThtFEN6K1//eEeR8WIOgsObdM1bFBxfCJ1DMZZDXQT6Dgg4Kt4EmZoYgZp4OIZZDfDtInkH/CZqXnWYFtOz2l9A1owmzPTptVl5/3u9C5aPZHtke2R7ZHtke3RyarzrsZbfrIf1otkeT3JkOIE03gLzO8RnkdJDLoKdTfFPyk+UbZzUUIqVb/+8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f4cb.png
// module id = 1026
// module chunks = 0